<div class="container-fluid">
  <h5 mat-dialog-title i18n>Send Arrival Notification</h5>
  <ng-container *ngIf="notifyAllowed; then sendArrival; else noContactsSetup"></ng-container>

  <ng-template #noContactsSetup>
    <p i18n>There are no contacts configured to receive arrival notifications. Contact your office to setup notification contacts. </p>
  </ng-template>

  <ng-template #sendArrival>
    <div mat-dialog-content>
      <p i18n>Send an arrival notification to the customer. Select a time until arrival and optionally enter a short note that will send an SMS or email to signal your arrival.</p>
      <form #arrivalNotificationForm="ngForm" (ngSubmit)="sendArrivalNotification(arrivalNotificationForm)">
        <div class="form-group row col-sm-8">
          <label for="selectedArrival" class="col-form-label">
            <span class="warning">* </span><span i18n>Select Arrival Time</span>
          </label>
          <div class=" mb-2">
            <select class="form-control select-bidit" id="selectedArrival" name="selectedArrival"
                    required=""
                    [(ngModel)]="arrivalData.arrivalInterval" #selectedArrival="ngModel">
              <option [ngValue]=null>-</option>
              <option [ngValue]=15>15 Minutes </option>
              <option [ngValue]=30>30 Minutes </option>
              <option [ngValue]=60>1 Hour </option>
              <option [ngValue]=90>1.5 Hours </option>
            </select>
            <div [hidden]="!arrivalNotificationForm.submitted || selectedArrival.valid"
                 class="alert alert-danger" i18n>Select an arrival tiime</div>
          </div>
          <div>
            <label for="arrivalComments" class="col-form-label">Comments</label>
            <textarea name="arrivalComments" id="arrivalComments"
                      [(ngModel)]="arrivalData.notificationComment" #arrivalComments="ngModel"
                      class="form-control" rows="3"></textarea>
          </div>
        </div>
        <div *ngIf="!isRequesting" class="float-end">
          <button type="submit" class="btn btn-bidit-submit mr-1" cdkFocusInitial i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </form>
    </div>
  </ng-template>
</div>

